import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { MerklisteService } from '../services/merkliste.service';
import { DatePipe, Location } from '@angular/common'; // Importiere Location

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {
  doc: any;

  constructor(
    private merklisteService: MerklisteService,
    private changeDetectorRef: ChangeDetectorRef,
    private location: Location,
    private datePipe: DatePipe, @Inject(LOCALE_ID) private locale: string,
    // Füge Location zum Konstruktor hinzu
  ) {}

  ngOnInit() {
    this.doc = this.merklisteService.getAllObjects();
      console.log('inside PrintComponent', this.doc);
    // Stelle sicher, dass Angular alle anstehenden Änderungen erkennt und anwendet
    this.changeDetectorRef.detectChanges();

    // Verzögerung einfügen, um sicherzustellen, dass die Änderungen gerendert wurden
    setTimeout(() => {
      this.printDocument();
    }, 2000); // Du kannst mit der Zeit experimentieren, um zu sehen, was am besten funktioniert

  }
  

  printDocument() {
    window.print();
    // this.location.back();
  }

  getFormattedDate(date: string) {
    if (date.length === 4 && !isNaN(Number(date))) {
      // It's a year
      return date;
    }
  
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      // If it is a valid date, we will format it
      return this.datePipe.transform(parsedDate, 'dd. MMMM yyyy', undefined, this.locale);
    }
  
    return date;  // If it's not a valid date, return the original string
  }
}
